import { ITelemetryItem } from "@microsoft/applicationinsights-web";

export class TelemetryInitializer {
	handler: (envelop: ITelemetryItem) => boolean | void
}
